export default `
  /* Custom classes */
  .ais-Highlight {
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.2188rem;
    font-family: var(--primary);
  
    @media screen and (min-width: 1024px) {
      font-size: 0.875rem;
      font-weight: 700;
  
      &:first-child {
        font-size: 1rem;
      }
    }
  }
  
  .ais-Highlight-highlighted {
    font-size: 0.75rem;
    font-weight: 1.25rem;
    line-height: 1.2188rem;
    font-family: var(--primary);
    color: var(--gray-100);
    font-style: normal;
    @media screen and (min-width: 1024px) {
      font-size: 0.875rem;
      font-weight: 700;
  
      &:first-child {
        font-size: 1rem;
      }
    }
  }

`;
